import { render, staticRenderFns } from "./FormAgentTax.vue?vue&type=template&id=8913a5d8&"
import script from "./FormAgentTax.vue?vue&type=script&lang=js&"
export * from "./FormAgentTax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports